namespace app.legacy {
    "use strict";

    declare let SystemJS, System;
    
    export class LegacyCommunicationService {

        private startedLoadingCallback: Function;
        private currentStateChangeRequest = {
            request: null
        };

        /** @ngInject **/
        constructor(private $window: ng.IWindowService, private $rootScope: ng.IRootScopeService, private $state: ng.ui.IStateService,
                private msNavigationService, private $stateParams: ng.ui.IStateParamsService, private $http: ng.IHttpService,
                private properties: app.support.constants.Properties, private $q: ng.IQService, private stylesLoadingService,
                private $ocLazyLoad, private $mdDialog, private $translate, private $injector: ng.auto.IInjectorService) {
            $window.addEventListener("message", (event) => this.handleMessage(event), false);
            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => { 
                if (toState.name === "app.legacy" && $state.$current["name"] === "app.legacy") {
                    event.preventDefault();
                    this.currentStateChangeRequest.request = {
                        url: toParams.url
                    };
                    this.updateUrl(toParams.url);
                    this.$rootScope.$broadcast("legacyRouteChangedToRefresh", {
                        url: toParams.url
                    });
                }
            });
        }

        private handleMessage(event) {
            if (event.data.operation === "startedLoading") {
                this.startedLoadingCallback();
            } else if (event.data.operation == "startedLoadingState") {
                this.$rootScope["loadingProgress"] = true;
                this.$rootScope.$apply();
            } else if (event.data.operation === "finishedLoadingState") {
                this.$rootScope["loadingProgress"] = false;
                this.$rootScope.$apply();
                if (event.data.url) {
                    this.updateUrl(event.data.url);
                }
            } else if (event.data.operation === "changeStfDigitalState") {
                this.$state.go(event.data.state);
            } else if (event.data.operation === "$http.get") {
                let data = JSON.parse(event.data.data);
                this.$http.get(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data.data.arguments[0], data.data.arguments[1]).then((response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "success"}});
                }, (response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "error"}});
                });
            } else if (event.data.operation === "$http.post") {
                let data = JSON.parse(event.data.data);
                this.$http.post(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data.data.arguments[0], data.data.arguments[1]).then((response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "success"}});
                }, (response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "error"}});
                });
            } else if (event.data.operation === "$http.put") {
                let data = JSON.parse(event.data.data);
                this.$http.put(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data.data.arguments[0], data.data.arguments[1]).then((response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "success"}});
                }, (response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "error"}});
                });
            } else if (event.data.operation === "$http.delete") {
                let data = JSON.parse(event.data.data);
                this.$http.delete(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data.data.arguments[0], data.data.arguments[1]).then((response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "success"}});
                }, (response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "error"}});
                });
            } else if (event.data.operation === "getBinary") {
                let data = JSON.parse(event.data.data);
                let contexto = data.data.context ? data.data.context : this.$stateParams["context"];
                this.$http.get(this.properties.apiUrl + "/" + contexto + "/" + data.data.arguments[0], {responseType: "arraybuffer"}).then((response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "success"}});
                }, (response) => {
                    this.$rootScope.$broadcast("legacy:callback", {"id": data.id, "data": {"response": {"data": response.data, "status": response.status}, "status": "error"}});
                });
            } else if (event.data.operation === "callService") {
                let data = JSON.parse(event.data.data);
                this.loadStfDigitalBundle(this.$stateParams["context"]).then((loadedModule) => {
                    let service = this.$injector.get(data.service);
                    service[data.method].apply(service, data.params);
                });
            }
        }
        
        private loadStfDigitalBundle(context: string): ng.IPromise<{}> {
            let deferredState = this.$q.defer();
            
            let alert = this.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.TITULO'))
                .textContent(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.MSG'))
                .ariaLabel(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.ALERTA'))
                .ok(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.OK'));
            
            function fnErr(err) {
                deferredState.reject();
                this.$mdDialog.show(alert);
            }
            
            let bundle: string = context + '/bundle';
            
            var styleUrl = SystemJS.baseURL + context + '/style.css';
            this.$q.all([System.import(bundle), this.stylesLoadingService.loadStyle(styleUrl)]).then(() => {
                System.import(context + "/legacy-integration").then((loaded) => {
                    var newModule = loaded;
                    
                    if (!loaded.name) {
                        var key = Object.keys(loaded);
                        newModule = loaded[key[0]];
                    }
                    //Carrega o módulo angular importado
                    this.$ocLazyLoad.load(newModule).then(function(loadedModule) {
                        deferredState.resolve(loadedModule);
                    }, fnErr);
                }, fnErr);
            });
            return deferredState.promise;
        }
        
        private updateUrl(url): void {
            this.$state.transitionTo("app.legacy", {
                context: this.$stateParams["context"],
                url: url
            }, {
                location: true,
                inherit: false,
                relative: this.$state.$current,
                notify: false
            });
            this.$stateParams["url"] = url;
            this.$rootScope.$broadcast("legacyRouteChanged");
        }

        public receiveStartedLoadingMessage(callback: Function) {
            this.startedLoadingCallback = callback;
        }

        public getCurrentStateChangeRequest() {
            return this.currentStateChangeRequest;
        }

    }

    angular
        .module('app.legacy')
        .service('app.legacy.LegacyCommunicationService', LegacyCommunicationService);
}